export const SET_PAGE_LOADING = 'SET_PAGE_LOADING';
export const SET_PROCESS_LOADING = 'SET_PROCESS_LOADING';
export const SET_BUTTON_LOADING = 'SET_BUTTON_LOADING'
export const SET_SUCCESS = 'SET_SUCCESS';
export const SET_ERROR = 'SET_ERROR';
export const SET_RANDOM_ACTION = 'SET_RANDOM_ACTION';
export const SET_EMAIL = 'SET_EMAIL';
export const GET_EMAIL = 'GET_EMAIL';

export const SET_TOGGLE = 'SET_TOGGLE';
export const GET_COUNTRY = 'GET_COUNTRY';
export const SET_COUNTRY = 'SET_COUNTRY';

export const GET_STATE = 'GET_STATE';
export const SET_STATE = 'SET_STATE';

export const SET_UPDATE_PASSWORD_ERROR = 'SET_UPDATE_PASSWORD_ERROR';

export const GET_BANKS = 'GET_BANKS';
export const SET_BANKS = 'SET_BANKS';
export const UPDATE_BANK_ACCOUNT_DETAILS = 'UPDATE_BANK_ACCOUNT_DETAILS';

export const SET_MODAL = 'SET_MODAL';
export const SET_404 = 'SET_404';
export const SET_DETAIL_NOT_FOUND = 'SET_DETAIL_NOT_FOUND';

// todo: uploadKycWithBVN --> In progress
export const UPLOAD_KYC_WITH_BVN = 'UPLOAD_KYC_WITH_BVN';
export const UPLOAD_KYC_WITH_BVN_SUCCESS = 'UPLOAD_KYC_WITH_BVN_SUCCESS';
export const UPLOAD_KYC_WITH_BVN_FAILURE = 'UPLOAD_KYC_WITH_BVN_FAILURE';
